import React from "react"
import { useTranslation } from "react-i18next"
import { styled } from "@mui/material"

import { useAppDispatch, useAppSelector } from "redux/hooks"
import { selectFetchStatus } from "redux/features/payment_schedule/paymentScheduleSlice"
import { makeDownloadPaymentSchedule } from "redux/features/payment_schedule/paymentScheduleDownloadThunk"
import Button from "components/ui/Button"
import { DebtType } from "types"
import { colors } from "theme"

type Props = {
  debt: DebtType
  paymentScheduleId: string
}

const DownloadComponent = ({
  debt,
  paymentScheduleId,
  ...restProps
}: Props) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const { is_white } = debt
  const isVisible = Boolean(!is_white)

  const fetchStatus = useAppSelector((state) => selectFetchStatus(state))

  const handleDownload = () => {
    if (!fetchStatus.isFetching) {
      dispatch(
        makeDownloadPaymentSchedule({ payment_schedule_id: paymentScheduleId }),
      ).then(({ url }) => {
        window.open(url)
      })
    }
  }

  return (
    <>
      {isVisible && (
        <Download
          {...restProps}
          disabled={fetchStatus.isFetching}
          onClick={handleDownload}
        >
          {t("common.download")}
        </Download>
      )}
    </>
  )
}

export default DownloadComponent

const Download = styled(Button)(({ theme }) => ({
  background: colors.lightPersianGreen,
  color: theme.palette.primary.main,
  borderRadius: "21px",
  fontWeight: "600",
  height: "32px",
  maxWidth: "175px",
  padding: "0 12px",
  margin: "12px 0 0 0",
  width: "auto",
  zIndex: 10,
  [theme.breakpoints.down("lg")]: {
    margin: "7px 0 0 0",
  },
}))
